import { render, staticRenderFns } from "./DailyChatSubscribe.vue?vue&type=template&id=13f39fa0&scoped=true"
import script from "./DailyChatSubscribe.vue?vue&type=script&lang=js"
export * from "./DailyChatSubscribe.vue?vue&type=script&lang=js"
import style0 from "./DailyChatSubscribe.vue?vue&type=style&index=0&id=13f39fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f39fa0",
  null
  
)

export default component.exports